export default __webpack_public_path__ + "static/media/deposit-withdraw.8e09ebc4.svg";